// src/components/titlebar/styles/titleBarStyles.ts

import { Box, Button, IconButton, Typography, styled } from "@mui/material"
import { uiColors } from "@shared/components/theme"

export const TitleBarContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: "35px",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  backdropFilter: "blur(20px)",
  WebkitBackdropFilter: "blur(20px)",
  borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 200,
  WebkitAppRegion: "drag",
  paddingLeft: "16px",
  paddingRight: "16px",
  overflow: "hidden",
}))

export const MenuButton = styled(Button)({
  minHeight: "24px",
  height: "24px",
  minWidth: "80px",
  fontSize: "12px",
  color: "rgba(90, 90, 90,0.8)",
  textTransform: "none",
  borderRadius: "4px",
  padding: "2px 8px",
  WebkitAppRegion: "no-drag",
  flexShrink: 0,
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
  },
})

export const ServerMenuButton = styled(MenuButton)({
  minWidth: "150px",
})

export const ViewMenuButton = styled(MenuButton)({
  minWidth: "60px",
})

export const HelpMenuButton = styled(MenuButton)({
  minWidth: "70px",
})

export const HomeButton = styled(Button)({
  minHeight: "24px",
  height: "24px",
  minWidth: "90px",
  fontSize: "12px",
  color: "rgba(90, 90, 90, 0.8)",
  textTransform: "none",
  borderRadius: "4px",
  padding: "2px 8px",
  WebkitAppRegion: "no-drag",
  flexShrink: 0,
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "rgba(25, 118, 210, 0.08)",
    color: "rgba(25, 118, 210, 0.9)",
  },
})

export const InquiryButton = styled(HomeButton)({
  minWidth: "96px",
  color: "#d9480f",
  "&:hover": {
    backgroundColor: "rgba(217, 72, 15, 0.1)",
    color: "#b9380a",
  },
})

export const WindowControlsContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  WebkitAppRegion: "no-drag",
})

export const ZoomControlsContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginLeft: "16px",
  WebkitAppRegion: "no-drag",
})

export const ZoomButton = styled(IconButton)({
  width: "28px",
  height: "28px",
  borderRadius: "50%",
  minWidth: "28px",
  padding: "0",
  backgroundColor: "transparent",
  border: "none",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
  },
  "& .MuiSvgIcon-root": {
    fontSize: "24px",
    color: "rgba(0, 0, 0, 0.7)",
  },
})

export const ControlButton = styled(IconButton, {
  shouldForwardProp: prop => prop !== "controlType",
})<{
  controlType: "minimize" | "maximize" | "close"
}>(({ controlType }) => ({
  width: "13px",
  height: "13px",
  borderRadius: "50%",
  minWidth: "13px",
  padding: "0",
  border: "1px solid rgba(0, 0, 0, 0.1)",
  backgroundColor:
    controlType === "close"
      ? uiColors.windowControl.close
      : controlType === "minimize"
        ? uiColors.windowControl.minimize
        : uiColors.windowControl.maximize,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    opacity: 0.8,
  },
  "& .MuiSvgIcon-root": {
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.9)",
    display: "none",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  "&:hover .MuiSvgIcon-root": {
    display: "block",
    color: "rgba(0, 0, 0, 1)",
  },
}))

export const TitleText = styled(Typography)({
  fontSize: "16px",
  fontWeight: 500,
  color: "rgba(0, 0, 0, 0.8)",
  userSelect: "none",
  textAlign: "center",
})

export const LeftSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  flex: "0 0 auto",
  minWidth: "300px",
  justifyContent: "flex-start",
})

export const CenterSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 10,
  flex: "1",
})

export const RightSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "15px",
  flex: "1",
  justifyContent: "flex-end",
})

// 공통 메뉴 스타일
export const menuPaperStyle = {
  mt: 0.5,
  minWidth: 160,
  backgroundColor: "rgba(248, 249, 250, 0.5)",
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
  borderRadius: "12px",
  border: "1px solid rgba(0, 0, 0, 0.08)",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
  "& .MuiMenuItem-root": {
    fontSize: "15px",
    minHeight: "32px",
    paddingTop: "6px",
    paddingBottom: "6px",
    color: "rgba(0, 0, 0, 0.87)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
    "&.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.38)",
    },
  },
}

